{
  "download": "Download active tab summary in PDF",
  "drawer": {
    "apply": "Apply",
    "description": "Deselect charts you wish to hide",
    "group": {
      "circuit": "Circuit {{graph}}",
      "site": "Site {{graph}}"
    },
    "header": "Show/Hide charts",
    "title": "Performance"
  },
  "graphs": {
    "annotations": {
      "good": "Good quality",
      "poor": "Poor quality"
    },
    "formatters": {
      "down": "{{label}} Down",
      "level": "Level {{level}}",
      "max": "{{label}} Max",
      "min": "{{label}} Min",
      "up": "{{label}} Up"
    },
    "not_found": "Graph not found",
    "tooltip": "To zoom in on a portion of a graph: click and drag the cursor over the portion of the graph to explore. On a touch-based device, use a pinching two-finger gesture.\nTo pan a graph (shift the time range): Hold down the control key and drag the cursor in the desired direction. On a touch-based device: use one finger to drag the graph in the desired direction.",
    "type": {
      "cellular_connection": {
        "row": {
          "connection_status": "Radio connection status",
          "network_carrier": "Network carrier",
          "network_type": "Network type"
        },
        "title": "Cellular connection status"
      },
      "cellular_quality_rsrp": {
        "labels": {
          "RSRP": "RSRP (dBm)"
        },
        "title": "RSRP (dBm)",
        "tooltip": "Reference Signal Received Power (RSRP) measures the power level of the reference signal received by a device from a cellular tower."
      },
      "cellular_quality_rsrq": {
        "labels": {
          "RSRQ": "RSRQ (dB)"
        },
        "title": "RSRQ (dB)",
        "tooltip": "Reference Signal Received Quality (RSRQ) evaluates the quality of the reference signal by considering the ratio of RSRP to total received power (RSSI)."
      },
      "cellular_quality_rssi": {
        "labels": {
          "RSSI": "RSSI (dBm)"
        },
        "title": "RSSI (dBm)",
        "tooltip": "Received Signal Strength Indicator (RSSI) represents the total received power, including both useful signal and interference."
      },
      "cellular_quality_snr": {
        "labels": {
          "SNR": "SINR (dB)"
        },
        "title": "SINR (dB)",
        "tooltip": "Signal-to-Interference-plus-Noise Ratio (SINR) measures the ratio of the desired signal power to the sum of interference and noise. A higher SINR indicates better signal quality and improved data transmission reliability."
      },
      "cellular_signal_quality": {
        "title": "Signal quality"
      },
      "cellular_summary": {
        "title": "Cellular summary"
      },
      "site_latency": {
        "labels": {
          "Latency": "Latency",
          "Loss": "Loss"
        },
        "title": "Packet latency and loss",
        "tooltip": "Displays the average latency the site experiences (in milliseconds), and highlights occurrences of packet loss (expressed as a percentage of total packets)."
      },
      "site_throughput": {
        "labels": {
          "Throughput": "Throughput"
        },
        "title": "Throughput",
        "tooltip": "The overall site throughput analyzed in terms of average, minimum, and maximum values over a fixed time window."
      },
      "wan_capacity": {
        "labels": {
          "Limit": "Limit"
        },
        "title": "Capacity",
        "tooltip": "The detected bandwidth of the circuit."
      },
      "wan_health": {
        "labels": {
          "Jitter": "Jitter",
          "Latency": "Latency",
          "Loss": "Loss"
        },
        "title": "Alarm Levels",
        "tooltip": "Circuit performance is categorized into alarm levels ranging from 0 to 7, based on latency, jitter, and loss at any given moment. Level 0 indicates a healthy circuit, while level 7 signifies that the circuit is down. As the circuit's performance deteriorates, the alarm level increases accordingly."
      },
      "wan_throughput": {
        "labels": {
          "QC0": "Other",
          "QC1": "Bulk Data",
          "QC2": "Interactive",
          "QC3": "Urgent",
          "QC4": "Real-Time",
          "QC5": "VoIP",
          "QCMgmt": "SD-WAN"
        },
        "title": "Throughput",
        "tooltip": {
          "bulk_data": "Bulk Data: Netflix, YouTube, Dropbox uploads, other large HTTP(s) or FTP streams",
          "interactive": "Interactive: FTP, VPNs, SNMP, HTTP",
          "other": "Other: Anything not matched for the above",
          "real_time": "Real-Time: ICMP, DNS, SSH",
          "sd_wan": "SD-WAN: General overhead for SD- monitoring and configuration.",
          "title": "Circuit-level throughput broken down into traffic categories:",
          "urgent": "Remote Desktop, Citrix, Interactive Applications",
          "voip": "VoIP: VoIP (signaling and media)"
        }
      }
    }
  },
  "groups": {
    "graphs": {
      "circuit": "Name: {{name}} | Usage: {{usage}}",
      "configure-circuit": "Go to circuit configuration",
      "site": "Overall Performance Charts",
      "wan1": "WAN1 Performance",
      "wan2": "WAN2 Performance",
      "wan3": "WAN3 Performance",
      "wan4": "WAN4 Performance",
      "wan4_cellular": "WAN4 cellular performance"
    },
    "toggles": {
      "site": "Overall",
      "wan1": "WAN1",
      "wan2": "WAN2",
      "wan3": "WAN3",
      "wan4": "WAN4",
      "wan4_cellular": "WAN4 (Cellular)"
    }
  },
  "header": "Performance",
  "options": "Chart Options",
  "pdf": "{{site}} - Performance"
}
